export default Backbone.Model.extend({
  initialize: function () {
    var full_name = this.get("name_first") + " ";
    if (!_.isNull(this.get("name_middle"))) full_name += this.get("name_middle") + " ";
    if (!_.isNull(this.get("name_nickname"))) full_name += "'" + this.get("name_nickname") + "' ";
    full_name += this.get("name_last");
    this.set("full_name", full_name);
  }
});